import { Image } from 'ol/layer'
import {ImageWMS } from 'ol/source'

import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';

function BaseLayer(BaseLayer, usertype) {
    
    //console.log("WMS address: "+process.env.REACT_APP_WMS_1)
    const source1 = process.env.REACT_APP_WMS_1;
    let blayer = "";
    let wmsSource;

    switch(BaseLayer){
        case "osmm":
        let osmmLayer = process.env.REACT_APP_LAYER_OSMM;
        if (usertype === 'gia') { osmmLayer = process.env.REACT_APP_LAYER_GIA_OSMM; }
        wmsSource = new TileWMS({
            url: source1,
            params: {'LAYERS': osmmLayer},
            serverType: 'geoserver',
            });
        blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;
        case "osmmbw":
        let osmmbwLayer = process.env.REACT_APP_LAYER_OSMMBW;
        if (usertype === 'gia') { osmmbwLayer = process.env.REACT_APP_LAYER_GIA_OSMMBW; }
        wmsSource = new TileWMS({
            url: source1,
            params: {'LAYERS': osmmbwLayer},
            serverType: 'geoserver',
            });
        blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;
        case "os10k":
            wmsSource = new TileWMS({
                url: source1,
                params: {'LAYERS': process.env.REACT_APP_LAYER_OML},
                serverType: 'geoserver',
                });
            blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;
        case "os25k":
            wmsSource = new TileWMS({
                url: source1,
                params: {'LAYERS': process.env.REACT_APP_LAYER_25k},
                serverType: 'geoserver',
                });
            blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;
        case "os50k":
            wmsSource = new TileWMS({
                url: source1,
                params: {'LAYERS': process.env.REACT_APP_LAYER_50k},
                serverType: 'geoserver',
                });
            blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;
        case "os250k":
            wmsSource = new TileWMS({
                url: source1,
                params: {'LAYERS': process.env.REACT_APP_LAYER_250k},
                serverType: 'geoserver',
                });
            blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;
        case "aerial":
            wmsSource = new TileWMS({
                url: source1,
                params: {'LAYERS': process.env.REACT_APP_LAYER_AERIAL},
                serverType: 'geoserver',
                });
            blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;
        case "grid":
            const gridSource = new ImageWMS({
                url: source1,
                params: {'LAYERS': process.env.REACT_APP_LAYER_GRID},
                serverType: 'geoserver',
            });
            const grid = new Image({source: gridSource, name: 'grid'});
            blayer = grid;
        break;
        default:
        case "open": //This is the free open map stack
            wmsSource = new TileWMS({
                url: source1,
                params: {'LAYERS': process.env.REACT_APP_LAYER_OPEN},
                serverType: 'geoserver',
                });
            blayer = new TileLayer({source: wmsSource, name: 'basemap'});
        break;

    }
    return blayer;
}

export default BaseLayer;